'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var words = require('./words.js');
function constantCase(str) {
    var words$1 = words.words(str);
    return words$1.map(function(word) {
        return word.toUpperCase();
    }).join('_');
}
exports.constantCase = constantCase;
